import { Categories } from 'modules/categories/desktop';
import { getServerSideCategories } from 'modules/categories/shared';

export const getServerSideProps = getServerSideCategories;
export default Categories;
